import { ButtonGroup, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { FetchStatusEnum } from "../../../enums/fetchStatusEnum";
import i18nStore from "../../../i18n/store";
import { IncomeInviteSchema } from "../schemas";
import invitesStore from "../store";
import IncomeInvite from "./IncomeInvite";
import Box from "@mui/material/Box";


const InviteTabs = {
    income: 0,
    outcome: 1,
};

const Invites = observer(() => {
    const translations = i18nStore.getTranslations;
    const [invitesTab, setInvitesTab] = useState<number>(InviteTabs.income);

    useEffect(() => {
        invitesStore.prefetchData();
    }, []);
    if (invitesStore.getInvites.length === 0) return null;

    return (
        <Box sx={{ py: 2 }}>
            <ButtonGroup
                disableElevation
                variant="contained"
                aria-label="Disabled button group"
            >
                <Button
                    variant={invitesTab === InviteTabs.income ? "contained" : "outlined"}
                    onClick={() => setInvitesTab(InviteTabs.income)}
                    sx={{ py: 0, }}
                >
                    {translations._invites.in_projects}
                </Button>
                {/*<Button*/}
                {/*    variant={invitesTab === InviteTabs.outcome ? "contained" : "outlined"}*/}
                {/*    onClick={() => setInvitesTab(InviteTabs.outcome)}*/}
                {/*    sx={{ py: 0, }}*/}
                {/*>*/}
                {/*    {translations._invites.in_organizations}*/}
                {/*</Button>*/}
            </ButtonGroup>

            <Box py={2}>
                {invitesTab === InviteTabs.income && <IncomeInProjectsInvites />}
                {invitesTab === InviteTabs.outcome && <IncomeInOrganizationsInvites />}
            </Box>
        </Box>
    );
});

export default Invites;


function IncomeInProjectsInvites() {
    if (invitesStore.getFetchStatus === FetchStatusEnum.FETCHING) {
        return (
            <CircularProgress />
        );
    }

    return (
        <>
            {
                invitesStore.getInvites.map((invite: IncomeInviteSchema) => (
                    <IncomeInvite invite={invite} />
                ))
            }
        </>
    );
}

function IncomeInOrganizationsInvites() {
    return (
        <>
        </>
    );
}